import React, { useEffect, useState, useRef } from 'react';
import { Form, Row, Modal, Col, Table } from 'react-bootstrap';
import mime from 'mime';
import { docType, docTypeIds, docTypeList } from '../../components/constant';
import { ButtonContainer, StyledButton } from '../../StyledComponets';
import {
  getDocumentUploadResponse,
  uploadAttachment,
} from '../../app/equipment/uploadDocsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  getProjectData, resetProjectStateReducer
} from '../../app/projects/createProjectSlice';
import { getCustomerData } from '../../app/contact/getCustomerSlice';
import {
  fetchProjectDocumentsData,
  getProjectDocuments,
  resetDocumentsListReducer,
} from '../../app/projects/projectDocumentSlice';
import {
  fetchDocumentData,
  getProjectDocById,
  resetDocumentReducer,
} from '../../app/projects/projectSingleDocSlice';
import { resetCityStateReducer } from '../../app/contact/contactSlice';

export default function UploadDoc(props) {
  const { setSection, pageType } = props;

  const initialFormState = Object.keys(docType).reduce(
    (obj, item) => Object.assign(obj, { [item]: null }),
    {}
  );
  const [documentState, setDocumentState] = useState(initialFormState);
  const [uploadState, setUploadState] = useState(initialFormState);
  const [statusModal, showStatusModal] = useState({ show: false });
  const [lastDoctype, setLastDoctype] = useState('');
  const [viewDocExt, setViewDocExt] = useState('');
  const fileRef = useRef(null);
  const dispatch = useDispatch();
  const customerData = useSelector(getCustomerData);
  const uploadResponse = useSelector(getDocumentUploadResponse);
  const projectData = useSelector(getProjectData);
  const clickedDocument = useSelector(getProjectDocById);

  const onFileChange = (e, docType) => {
    setUploadState({ ...uploadState, [docType]: false });
    setDocumentState({ ...documentState, [docType]: e.target.files[0] });
  };

  useEffect(() => {
    if (uploadResponse && uploadResponse.includes('uploaded')) {
      setUploadState({ ...uploadState, [lastDoctype]: true });
    }
  }, [uploadResponse]);

  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {
      dispatch(resetDocumentsListReducer());
      dispatch(resetDocumentReducer());
    };
  }, []);

  useEffect(() => {
    if (projectData?.reponseMessage === 'Submitted' && projectData?.appNb) {
      showStatusModal({ show: true, state: 'success' });
      setDocumentState(initialFormState);
      setUploadState(initialFormState);
    }
  }, [projectData]);

  useEffect(() => {
    if (clickedDocument) {
      // var doc = viewDocKey.split('\\.');
      // var docType = doc[1];
      // var contentType = `application/${docType}`;
      // const data = 'data:' + contentType + ';base64,' + clickedDocument;
      //download(data, 'myfile.pdf');
      const byteCharacters = atob(clickedDocument.content);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mime.getType(viewDocExt) });
      const fileObjectURL = URL.createObjectURL(blob);
      window.open(fileObjectURL);
    }
  }, [clickedDocument]);

  useEffect(() => {
    if (props.formData?.data?.uploadState) {
      setUploadState(props.formData?.data?.uploadState);
    }
  }, [props.formData]);

  const checkDocs = (doneSt) => {
    if (
      doneSt[docType.ElecOneLnDraw] &&
      doneSt[docType.GenSpec] &&
      doneSt[docType.InvSpec] &&
      doneSt[docType.SiteDiagrams] &&
      doneSt[docType.preInstallPics] &&
      doneSt[docType.HomeLbIns] &&
      doneSt[docType.others]
    ) {
      return false;
    }
    return true;
  };

  const resetForm = () => {
    props.resetAppForm();
    dispatch(resetCityStateReducer());
    dispatch(resetProjectStateReducer());
    showStatusModal({ show: false });
  };

  const uploadDocByType = (selectedDoc) => {
    const reqData = {
      DocType: selectedDoc,
      Content: documentState?.[selectedDoc],
      AppNb: projectData?.appNb,
      ProgramId: projectData?.programId,
      ProjectId: projectData?.projectId,
      PremiseNb: customerData?.premiseNb,
      AttachmentId: docTypeIds?.[selectedDoc],
      AttachmentFileName: documentState?.[selectedDoc]?.name,
      AttachmentName: selectedDoc,
      AccountNb: customerData?.accountNb,
    };
    setLastDoctype(selectedDoc);
    dispatch(uploadAttachment(reqData));
  };

  const submitEnrollment = () => {
    props.createOrSaveProject(null, 'Submit');
  };

  const onNextClick = () =>{
    setSection(true);
  }

  const onDocViewClick = (docDetails) => {
   const atId  = docDetails.docKey?.split('/')?.[0]==='ui' ? docDetails?.docKey :docDetails?.cprCustomId
    const reqObj = {
      // appNb: props?.appData?.appNb,
      // docKey: docDetails?.docKey,
      // premiseNb: props?.appData?.customer?.premiseNb,
      // acctNb:  props?.appData?.customer?.accountNb,
      // programId:  props?.appData?.cprProgramId,
      // projectNumber:  props?.appData?.cprProjectNb,
      projectId: props?.appData?.cprProjectId,
      ...(docDetails.docKey?.split('/')?.[0]==='ui' ? {docKey:docDetails?.docKey}:{attachmentid:docDetails?.cprCustomId}),
      asAFile: false,
    }
    setViewDocExt(docDetails?.docExt);
    dispatch(fetchDocumentData(reqObj));
  };

  const renderDoc = () => {
    return Object.keys(docTypeList).map(function (keyName, keyIndex) {
      return (
        <Row key={keyIndex}>
          <Col>
            <Form.Group controlId="formFileSm" className="mb-3">
              <Form.Text
                size="sm"
                style={{ margin: '2px' }}
                htmlFor="equipOption"
              >
                {docTypeList[keyName]}
              </Form.Text>
              <Form.Control
                ref={fileRef}
                type="file"
                name="formFile"
                accept="*"
                size="sm"
                onChange={(e) => onFileChange(e, keyName)}
              />
            </Form.Group>
          </Col>
          <Col>
            {documentState[keyName] && !uploadState[keyName] && (
              <StyledButton
                style={{ marginTop: '24px' }}
                btnType="primary"
                variant="dark"
                size="sm"
                onClick={() => uploadDocByType(keyName)}
              >
                Upload
              </StyledButton>
            )}
            {uploadState[keyName] && (
              <FontAwesomeIcon
                style={{
                  color: 'green',
                  paddingTop: '30px',
                  verticalAlign: 'middle',
                }}
                icon={['fas', 'fa-circle-check']}
                size="md"
              />
            )}
          </Col>
        </Row>
      );
    });
  };

  const renderDocView = (projectDocs) => {
    return (
      projectDocs?.length > 0 && (
        <Table>
          <tbody>
            {projectDocs.map((doc) => (
              <tr>
                <td>{doc.docType}-{doc.docName}</td>
                <td>
                  <a
                    className="order-grid-hyper"
                    onClick={() => onDocViewClick(doc)}
                  >
                    View
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )
    );
  };

  return (
    <>
      {pageType !== 'view' ? renderDoc() : renderDocView(props.formData?.data)}
      {pageType !== 'view' && (
        <ButtonContainer>
          <StyledButton
            btnType="secondary"
            variant="dark"
            size="md"
            onClick={() => {
              setSection(false, { uploadState, documentState });
            }}
          >
            Back
          </StyledButton>
          <StyledButton
            type="submit"
            btnType="primary"
            variant="dark"
            size="md"
            disabled={checkDocs(uploadState)}
            onClick={onNextClick}
          >
            Next
          </StyledButton>
        </ButtonContainer>
      )}
      <Modal
        centered
        size="lg"
        onShow={() => {}}
        onExited={() => {}}
        show={statusModal?.show}
        onHide={() => {
          resetForm();
        }}
      >
        <Modal.Header closeButton>
          {statusModal?.state === 'success' && (
            <Modal.Title>{`Interconnection Service Request Submitted-Application No: ${projectData?.appNb}`}</Modal.Title>
          )}
          {statusModal?.state === 'failed' && (
            <Modal.Title>{`Error Occured during the process`}</Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          {statusModal?.state === 'success' && (
            <h5 className="text-center">
              {`Thankyou for submitting an Interconnection Service Request`}
            </h5>
          )}
          {statusModal?.state === 'failed' && (
            <h5 className="text-center">
              {`Please contact admin or try again later`}
            </h5>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
